import { useQuery } from "@tanstack/react-query";
import { queryCurrentUser } from "supabase/users";

export const useQueryCurrentUser = () => {
  const {
    isLoading,
    isError,
    error,
    data: user,
  } = useQuery({
    queryKey: ["currentUser"],
    queryFn: () => {
      return queryCurrentUser();
    },
  });

  return { isLoading, isError, error, user };
};
